<section class="row m-0">
	<div class="d-flex align-items-center justify-content-between w-100 pr-4">
		<inputfield class="col-24" label="id" [ngModel]="model.id" readonly></inputfield>
		<i class="mdi-content-content-copy mdi-xl cursor-pointer" (click)="copyToClipboard(model.id)"></i>
	</div>
	<div class="d-flex align-items-center justify-content-between w-100 pr-4">
		<inputfield class="col-24" label="clientEid" [ngModel]="model.clientEid" readonly></inputfield>
		<i class="mdi-content-content-copy mdi-xl cursor-pointer" (click)="copyToClipboard(model.clientEid)"></i>
	</div>
</section>